import * as liquid_browser from './node_modules-liquidjs-dist-liquid.browser.js';
import { getAugmentedNamespace } from './_virtual-_commonjsHelpers.js';

var require$$5 = /*@__PURE__*/getAugmentedNamespace(liquid_browser);

export { require$$5 as default };
//# sourceMappingURL=_virtual-liquid.browser.js.map
